import httpRequest from 'utils/httpRequest';
import SETTINGS from '../settings';

const withTemplateHost = url => `${SETTINGS.TEMPLATE_HOST}/${url}`;

const withTemplateHeaders = headers => ({
  'Content-Type': 'application/json',
  ...headers,
});

/**
 * Template POST httpRequest.
 * @param {string} url
 * @param {object} body
 * @param {object} headers
 * @param {object} opts
 * @returns {Response}
 */
const templateClientPostRequest = async (url, body = {}, headers = {}, opts = {}) => {
  const response = await httpRequest(withTemplateHost(url), {
    method: 'POST',
    headers: withTemplateHeaders(headers),
    body,
    ...opts,
  });

  return response;
};

/**
 * Template GET httpRequest.
 * @param {string} url
 * @param {object} headers
 * @param {object} opts
 * @returns {Response}
 */
const templateClientGetRequest = async (url, headers = {}, opts = {}) => {
  const response = await httpRequest(withTemplateHost(url), {
    method: 'GET',
    headers: withTemplateHeaders(headers),
    ...opts,
  });

  return response;
};

/**
 * Template generator httpRequest.
 * @param {string} accessToken
 * @param {object} template
 * @param {boolean} async
 * @param {object | Array<object>} data
 * @returns {Response}
 */
export const templateGeneratorRequest = async (accessToken, template, async, data) => {
  const response = await templateClientPostRequest(
    'generator',
    {
      product_id: template.id,
      version: template.version,
      async,
      data,
    },
    {
      Authorization: `Token ${accessToken}`,
    },
  );

  return response;
};

/**
 * Template TOC generator httpRequest.
 * @param {string} accessToken
 * @param {object} template
 * @param {object} data
 * @param {object} signal
 * @returns {Response}
 */
export const templateTocRequest = async (accessToken, template, data, signal) => {
  const response = await templateClientPostRequest(
    'toc',
    {
      product_id: template.id,
      version: template.version,
      data,
    },
    {
      Authorization: `Token ${accessToken}`,
    },
    {
      signal,
    },
  );

  return response;
};

/**
 * Template session details httpRequest.
 * @param {string} accessToken
 * @param {string} sessionId
 * @returns {Response}
 */
export const templateSessionRequest = async (accessToken, sessionId) => {
  const response = await templateClientGetRequest(
    `session?id=${sessionId}`,
    {
      Authorization: `Token ${accessToken}`,
    },
  );

  return response;
};
